// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

/* ==========  路由懒加载：按页面拆 chunk  ========== */
const Login = () => import(/* webpackChunkName: "login"       */ '@/views/Login.vue')
const Register = () => import(/* webpackChunkName: "register"    */ '@/views/Register.vue')
const Dashboard = () => import(/* webpackChunkName: "dashboard"   */ '@/views/Dashboard.vue')
const BookManagement = () => import(/* webpackChunkName: "book"        */ '@/views/BookManagement.vue')
const BorrowManagement = () => import(/* webpackChunkName: "borrow"      */ '@/views/BorrowManagement.vue')
const ApiDocument = () => import(/* webpackChunkName: "api-docs"    */ '@/views/ApiDocument.vue')
const SeatReservation = () => import(/* webpackChunkName: "seat"        */ '@/views/SeatReservation.vue')
const TicketSystem = () => import(/* webpackChunkName: "ticket"      */ '@/views/TicketSystem.vue')

/* 旧版模块（可整体打成一个 chunk，也可再细分） */
const old_SeatReservation = () => import(/* webpackChunkName: "old-seat" */ '@/views/old_SeatReservation.vue')
const old_RoomEditor = () => import(/* webpackChunkName: "old-room" */ '@/components/old_RoomEditor.vue')

/* ==========  路由表  ========== */
const routes = [
    { path: '/', redirect: '/login' },

    { path: '/login', name: 'Login', component: Login, meta: { title: '登录' } },
    { path: '/register', name: 'Register', component: Register, meta: { title: '注册' } },

    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '仪表盘', requiresAuth: true }
    },
    {
        path: '/books',
        name: 'BookManagement',
        component: BookManagement,
        meta: { title: '图书管理', requiresAuth: true }
    },
    {
        path: '/borrow',
        name: 'BorrowManagement',
        component: BorrowManagement,
        meta: { title: '借阅管理', requiresAuth: true }
    },
    {
        path: '/api-docs',
        name: 'ApiDocument',
        component: ApiDocument,
        meta: { title: '接口文档' }
    },

    /* 旧版选座 / 房间编辑 */
    {
        path: '/old/seat-reservation',
        name: 'old_SeatReservation',
        component: old_SeatReservation,
        meta: { title: '旧版选座', requiresAuth: true }
    },
    {
        path: '/old/room-editor',
        name: 'old_RoomEditor',
        component: old_RoomEditor,
        meta: { title: '旧版房间编辑', requiresAuth: true, requiresAdmin: true }
    },
    {
        path: '/old/room-editor/:roomId',
        name: 'old_RoomEditorWithId',
        component: old_RoomEditor,
        props: true,
        meta: { title: '编辑房间', requiresAuth: true, requiresAdmin: true }
    },

    /* 新版选座 & 工单 */
    {
        path: '/seat-reservation',
        name: 'SeatReservation',
        component: SeatReservation,
        meta: { title: '选座系统', requiresAuth: true }
    },
    {
        path: '/ticket',
        name: 'TicketSystem',
        component: TicketSystem,
        meta: { title: '工单系统' }
    }
]

/* ==========  创建路由实例  ========== */
const router = createRouter({
    mode: 'history',
    history: createWebHistory(),
    routes
})

/* ==========  全局前置守卫  ========== */
router.beforeEach((to, from, next) => {
    document.title = to.meta?.title
        ? `${to.meta.title} - 图书馆管理系统`
        : '图书馆管理系统'

    const isAuthenticated = localStorage.getItem('user') !== null
    if (to.meta.requiresAuth && !isAuthenticated) {
        next('/login')
    } else {
        next()
    }
})

export default router